import React from 'react';
import { useTranslation } from 'react-i18next';
import type { PublicScanSources } from '@brand24-original/llm-types';
import ReportSection from './ReportSection';
import './ReportSourceDomains.scss';

interface ReportSourceDomainsProps {
  sources: PublicScanSources;
}

export const ReportSourceDomains: React.FC<ReportSourceDomainsProps> = ({ sources }) => {
  const { t } = useTranslation();
  const domains = sources.topDomains;

  // Slajd bez danych w ogóle nie wchodzi do raportu — ani na stronie, ani w PDF.
  if (domains.length === 0) {
    return null;
  }

  return (
    <ReportSection
      title={t('reportDomainsTitle')}
      titleAccent={t('reportDomainsTitleAccent')}
      subtitle={t('reportDomainsSubtitle')}
    >
      <ol className="report-domains">
        {domains.map((entry, index) => (
          <li
            key={entry.domain}
            className={`report-domains__card${
              entry.isTrackedDomain ? ' report-domains__card--tracked' : ''
            }`}
          >
            <span className="report-domains__rank">{index + 1}</span>

            <div className="report-domains__main">
              <span className="report-domains__name" title={entry.domain}>
                {entry.domain}
              </span>
              <span className="report-domains__share">
                {t('reportDomainsShare', { value: entry.share })}
              </span>
              <div className="report-domains__track">
                {/* Pełna skala 0-100% — pasek pokazuje udział w CAŁOŚCI cytowań, nie względem lidera. */}
                <div
                  className="report-domains__bar"
                  style={{ width: `${Math.min(entry.share, 100)}%` }}
                />
              </div>
            </div>

            <span className="report-domains__citations">{entry.citations}</span>
          </li>
        ))}
      </ol>
    </ReportSection>
  );
};

export default ReportSourceDomains;
